/**
 * How one row of the clinic's service list behaves on the booking widget
 * (docs/ux/screens/BusinessPublicProfileScreen.md, Services).
 *
 * There used to be two lists: an informational one under the header and a
 * selector inside the booking section, naming the same services twice. They
 * are one list now, and each row is in exactly one of three states:
 *
 * - **selectable**: a logged-in Consumer, and the clinic has open times;
 * - **readOnly**: anybody else, and the clinic has open times. The row is
 *   informational and stays full strength, because the service *is* bookable,
 *   just not by this viewer until they log in;
 * - **unavailable**: the clinic has no open times at any Service Location, so
 *   nothing can be requested whoever is looking. The row is dimmed and says so.
 *
 * Availability is clinic-wide on purpose. Any open hour can be requested for
 * any Service (H39, H45), so no rule makes one service bookable and another
 * not; a Where with no times is the time picker's message, not the list's.
 */
export type ServiceRowState = "selectable" | "readOnly" | "unavailable";

export function hasOpenTimes(
  days: readonly { blocks: readonly unknown[] }[],
): boolean {
  return days.some((day) => day.blocks.length > 0);
}

export function serviceRowState(
  viewer: "consumer" | "guest" | "other",
  clinicDays: readonly { blocks: readonly unknown[] }[],
): ServiceRowState {
  if (!hasOpenTimes(clinicDays)) return "unavailable";
  return viewer === "consumer" ? "selectable" : "readOnly";
}
